<template>
    <div :class="['input-set', classActive, classError]">
        <label class="label" v-if="label">{{ label }}</label>
        <i v-if="tooltip" class="info-icon"
            v-tooltip="{
                content: tooltip,
                classes: tooltipClasses
            }">
            <img src="/assets/images/far-info-circle.svg" alt="info-icon">
        </i>
        <input
            v-if="!isDropdown"
            ref="inputSet"
            :type="inputType"
            :value="value"
            :name="`${this.name}`"
            :placeholder="`${this.placeholder}`"
            :class="['form-control']"
            :maxlength="maxLength"
            :tabindex="tabIndex"
            @input.once="updateValue($event.target.value)"
            @input="updateValue($event.target.value)"
            @focus="onFocus"
            @blur="onBlur"
            v-on:keyup.enter="onEnter"
            :autocomplete="autocomplete"
        >
        <dropdown
            v-else
            :name="name"
            :isNavbarDropdown="false"
            :inInputSet="true"
            :entries="entries"
            :formatText="x => x"
            :formatValue="x => x"
            :selected="selected"
            :active="active"
            :error="hasError"
            :placeholder="placeholder"
            :tabIndex="tabIndex"
            @update:selected="onDropdownChange"
            @onToggle="onDropdownToggle"
            @dropdownOnBlur="onBlur"
            @dropdownOnFocus="onFocus"
        ></dropdown>
    </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import zxcvbn from 'zxcvbn';
import Dropdown from '~/components/dashboard/components/dropdown.vue';

export default {
    components: { Dropdown },
    data() {
        return {
            active: false,
        };
    },
    props: {
        type: String,
        name: String,
        value: String,
        label: String,
        placeholder: String,
        hasError: Boolean,
        showInput: {
            type: Boolean,
            default: true,
        },
        maxLength: {
            type: Number,
            default: null,
        },
        isDropdown: {
            type: Boolean,
            default: false,
        },
        entries: Array,
        selected: String,
        tooltip: String,
        tooltipClasses: Array,
        tabIndex: {
            type: Number,
            default: 1,
        },
        autocomplete: {
            type: String,
            default: 'off',
        },
    },
    computed: {
        inputType() {
            return this.showInput ? this.type : 'password';
        },
        classActive() {
            return this.active ? 'active' : '';
        },
        classError() {
            return this.hasError ? 'error' : '';
        },
    },
    methods: {
        updateValue(value) {
            this.$emit('input', value);
            this.$emit('inputOnType', this.name);
        },
        onFocus() {
            this.active = true;
            this.$emit('inputOnFocus', this.name);
        },
        onBlur() {
            this.active = false;
            this.$emit('inputOnBlur', this.name);
        },
        onEnter() {
            this.$emit('inputOnEnter', this.name);
        },
        onDropdownChange(selected) {
            this.$emit('onDropdownChange', this.name, selected);
        },
        onDropdownToggle(toggle) {
            this.active = toggle;
        },
    },
};
</script>

<style lang="scss">
@import "global/default";
@import '~/scss/component/_tooltipp.scss';

    .input-set {
        .label {
            font-size: $font-size-label;
            color: $color-neutral-dark-200;
        }
        input {
            color: $color-neutral-dark-400;
        }
        .info-icon {
            cursor: pointer;
            color: $color-neutral-dark-100;
            float: right;
            margin-right: 0.75rem;
            margin-top: 0.1rem;
            img {
                width: $font-size-label;
                height: $font-size-label;
            }
        }
        &.active {
            .label {
                font-size: $font-size-label;
                color: $color-secondary-200;
            }
            input {
                border: 1px solid $color-semantic-blue-300;
                box-shadow: none;
                color: $color-neutral-dark-400;
            }
        }
        &.error {
            .label {
                font-size: $font-size-label;
                color: $color-semantic-red-200;
            }
            input {
                border: 1px solid $color-semantic-red-300;
                box-shadow: none;
                color: $color-neutral-dark-400;
            }
        }
    }

</style>
